import Wordmark, { StarGlyph } from "@/components/Wordmark";

export default function ShareCard({ pattern }) {
    return (
        <div
            data-testid="result-share-card"
            className="relative overflow-hidden rounded-3xl border border-white/10 bg-abyss p-7 sm:p-9"
        >
            <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-celestial-blue/15 blur-3xl" />
            <div className="relative flex items-center justify-between">
                <Wordmark compact />
                <StarGlyph className="h-4 w-4 text-celestial-gold" />
            </div>
            <p className="mt-9 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                WHY THE FUCK DO I DO THAT?
            </p>
            <p
                data-testid="result-share-card-title"
                className="mt-3 font-display text-4xl text-celestial-gold sm:text-5xl"
            >
                {pattern.title}
            </p>
            <p
                data-testid="result-share-card-quote"
                className="mt-5 max-w-sm whitespace-pre-line text-[15px] leading-relaxed text-slate-300"
            >
                {pattern.shareQuote}
            </p>
            <div className="relative mt-9 border-t border-white/10 pt-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">
                    What's your default move?
                </p>
                <p className="mt-2 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                    <span>Take the SacredSpace Pattern Decoder.</span>
                    <StarGlyph className="ml-3 h-3 w-3 shrink-0 text-celestial-blue" />
                </p>
            </div>
        </div>
    );
}
